<template>
  <v-container class="fill-height">
    <v-responsive class="d-flex align-center text-center fill-height">
      <v-img
          contain
          height="200"
          src="/logo.svg"
      />

      <div class="text-h5 font-weight-light mt-4 mb-2">خوش آمدید</div>

      <h1 id="head" class="text-h4 text-md-h2 font-weight-bold mb-5"> بےبی سٹورم</h1>

      <div class="mb-3"></div>

      <v-row class="d-flex align-center justify-center">
        <v-col>
          <div class="text-h5 my-3">
            علم الاعداد ہندسوں پر مبنی علم ہے جو کہ ناموں میں چھپی معلومات سے پردہ اٹھانے میں استعمال ہوتا ہے۔ علم الاعداد کی رو سے کسی بھی نام کا حساب، اس کی قابلیت اور قدر آسانی سے معلوم کریں۔
            <br><strong>انتباہ!&ensp;</strong> یہ ایپ صرف معلوماتی مقاصد کے لیے تخلیق کی گئی ہے غرض اس کے نتائج کو مشورہ کے طور پر قبول کریں کیونکہ حقیقی علم صرف اللہ تعالٰی کے پاس ہے۔<br>اس لیے اس کو حتمی فیصلہ تسلیم کرنا اسلام میں جائز نہیں ہے۔
          </div>
        </v-col>
      </v-row>

      <v-row class="d-flex align-center justify-center">
        <v-col cols="auto">
          <v-btn
              color="primary"
              min-width="228"
              size="x-large"
              variant="flat"
              to="compute"
          >
            شروع کریں
          </v-btn>
        </v-col>
      </v-row>
    </v-responsive>
  </v-container>
</template>

<script>
export default {
  name: "HomeView"
}
</script>
